import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { useValidateIsNotEmptyArray } from "formvalidation/hooks";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";

interface Props {
  validatorKey: string
  value: server.dto.Currency[]
  onChange: (tags: server.dto.Currency[]) => void
}

const CurrenciesSelect = (props: Props) => {
  const selected = new Set(props.value.map(v => v.value));

  const validator = useValidateIsNotEmptyArray({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
  });

  const onChange = (currency: server.dto.Currency, checked: boolean) => {
    const newCurrencies = checked
      ? [...props.value, currency]
      : props.value.filter(c => c.value !== currency.value);
    props.onChange(newCurrencies);
  }

  return <div className="multiple-columns">
    {serverReference.currencies.map(opt => (
      <div className="margin-bottom-mini" key={opt.value}>
        <Checkbox
          error={validator.error.hasError}
          keyboardNavigationOptions={VerticalKeyboardNavigationGroup("currencySelect")}
          checked={selected.has(opt.value)}
          label={`${opt.value.toUpperCase()} (${opt.name})`}
          onChange={(_, checked) => { onChange(opt, checked); }}
        />
      </div>
    ))}
  </div>;
};

export default CurrenciesSelect;